import { ActionIcon, Button, Drawer, Group, Title } from "@mantine/core"
import { IconX } from "@tabler/icons-react"
import { RenderFilterOptions } from "./FilterOptions"
import { primaryColor } from "../../../../constants/theme"
import { ExtendedFacetResult } from "../../../../types/UserDocument";
import { useSearch } from "./SearchContext";

interface FilterModalProps {
    facets?: { [key: string]: ExtendedFacetResult[] };
    opened: boolean;
    onClose: () => void;
}

export const FilterModal = ({facets, opened, onClose}: FilterModalProps) => {

    const {resetFilters, filterCount} = useSearch();

    return (
        <Drawer opened={opened} onClose={onClose} position="right" size="sm" shadow="xl" offset={8} radius="md" withCloseButton={false}>
            <Drawer.Header>
                <Group justify="space-between" w='100%'>
                    <Button disabled={Boolean((filterCount ?? 0) === 0)} variant="transparent" color={primaryColor} p={1} onClick={resetFilters}>RESET</Button>
                    <Title order={3} fw='normal'>Filters</Title>
                    <ActionIcon variant="subtle" size="lg" color="black" onClick={onClose}>
                        <IconX size={20}></IconX>
                    </ActionIcon>
                </Group>
            </Drawer.Header>
            <Drawer.Body>
                <RenderFilterOptions facets={facets} />    
            </Drawer.Body>
        </Drawer>
    )
}